module.exports = __webpack_public_path__ + "static/media/tik.94a90ab0.jpeg";